function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import useControlled from '@mui/utils/useControlled';
import { useRtl } from '@mui/system/RtlProvider';
import { usePickersTranslations } from '../../../hooks/usePickersTranslations';
import { useUtils, useLocalizationContext } from '../useUtils';
import { mergeDateIntoReferenceDate, getSectionsBoundaries, validateSections, getDateFromDateSections, parseSelectedSections, getLocalizedDigits } from './useField.utils';
import { buildSectionsFromFormat } from './buildSectionsFromFormat';
import { useValueWithTimezone } from '../useValueWithTimezone';
import { getSectionTypeGranularity } from '../../utils/getDefaultReferenceDate';
export var useFieldState = function useFieldState(params) {
  var utils = useUtils();
  var translations = usePickersTranslations();
  var adapter = useLocalizationContext();
  var isRtl = useRtl();
  var valueManager = params.valueManager,
      fieldValueManager = params.fieldValueManager,
      valueType = params.valueType,
      validator = params.validator,
      internalProps = params.internalProps,
      _params$internalProps = params.internalProps,
      valueProp = _params$internalProps.value,
      defaultValue = _params$internalProps.defaultValue,
      referenceDateProp = _params$internalProps.referenceDate,
      onChange = _params$internalProps.onChange,
      format = _params$internalProps.format,
      _params$internalProps2 = _params$internalProps.formatDensity,
      formatDensity = _params$internalProps2 === void 0 ? 'dense' : _params$internalProps2,
      selectedSectionsProp = _params$internalProps.selectedSections,
      onSelectedSectionsChange = _params$internalProps.onSelectedSectionsChange,
      _params$internalProps3 = _params$internalProps.shouldRespectLeadingZeros,
      shouldRespectLeadingZeros = _params$internalProps3 === void 0 ? false : _params$internalProps3,
      timezoneProp = _params$internalProps.timezone,
      _params$internalProps4 = _params$internalProps.enableAccessibleFieldDOMStructure,
      enableAccessibleFieldDOMStructure = _params$internalProps4 === void 0 ? false : _params$internalProps4;

  var _useValueWithTimezone = useValueWithTimezone({
    timezone: timezoneProp,
    value: valueProp,
    defaultValue: defaultValue,
    onChange: onChange,
    valueManager: valueManager
  }),
      timezone = _useValueWithTimezone.timezone,
      valueFromTheOutside = _useValueWithTimezone.value,
      handleValueChange = _useValueWithTimezone.handleValueChange;

  var localizedDigits = React.useMemo(function () {
    return getLocalizedDigits(utils);
  }, [utils]);
  var sectionsValueBoundaries = React.useMemo(function () {
    return getSectionsBoundaries(utils, localizedDigits, timezone);
  }, [utils, localizedDigits, timezone]);
  var getSectionsFromValue = React.useCallback(function (value) {
    var fallbackSections = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return fieldValueManager.getSectionsFromValue(utils, value, fallbackSections, function (date) {
      return buildSectionsFromFormat({
        utils: utils,
        timezone: timezone,
        localeText: translations,
        localizedDigits: localizedDigits,
        format: format,
        date: date,
        formatDensity: formatDensity,
        shouldRespectLeadingZeros: shouldRespectLeadingZeros,
        enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
        isRtl: isRtl
      });
    });
  }, [fieldValueManager, format, translations, localizedDigits, isRtl, shouldRespectLeadingZeros, utils, formatDensity, timezone, enableAccessibleFieldDOMStructure]);

  var _React$useState = React.useState(function () {
    var sections = getSectionsFromValue(valueFromTheOutside);
    validateSections(sections, valueType);
    var stateWithoutReferenceDate = {
      sections: sections,
      value: valueFromTheOutside,
      referenceValue: valueManager.emptyValue,
      tempValueStrAndroid: null
    };
    var granularity = getSectionTypeGranularity(sections);
    var referenceValue = valueManager.getInitialReferenceValue({
      referenceDate: referenceDateProp,
      value: valueFromTheOutside,
      utils: utils,
      props: internalProps,
      granularity: granularity,
      timezone: timezone
    });
    return _extends({}, stateWithoutReferenceDate, {
      referenceValue: referenceValue
    });
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var _useControlled = useControlled({
    controlled: selectedSectionsProp,
    default: null,
    name: 'useField',
    state: 'selectedSections'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      selectedSections = _useControlled2[0],
      innerSetSelectedSections = _useControlled2[1];

  var setSelectedSections = function setSelectedSections(newSelectedSections) {
    innerSetSelectedSections(newSelectedSections);
    onSelectedSectionsChange === null || onSelectedSectionsChange === void 0 ? void 0 : onSelectedSectionsChange(newSelectedSections);
  };

  var parsedSelectedSections = React.useMemo(function () {
    return parseSelectedSections(selectedSections, state.sections);
  }, [selectedSections, state.sections]);
  var activeSectionIndex = parsedSelectedSections === 'all' ? 0 : parsedSelectedSections;

  var publishValue = function publishValue(_ref) {
    var value = _ref.value,
        referenceValue = _ref.referenceValue,
        sections = _ref.sections;
    setState(function (prevState) {
      return _extends({}, prevState, {
        sections: sections,
        value: value,
        referenceValue: referenceValue,
        tempValueStrAndroid: null
      });
    });

    if (valueManager.areValuesEqual(utils, state.value, value)) {
      return;
    }

    var context = {
      validationError: validator({
        adapter: adapter,
        value: value,
        props: _extends({}, internalProps, {
          value: value,
          timezone: timezone
        })
      })
    };
    handleValueChange(value, context);
  };

  var setSectionValue = function setSectionValue(sectionIndex, newSectionValue) {
    var newSections = _toConsumableArray(state.sections);

    newSections[sectionIndex] = _extends({}, newSections[sectionIndex], {
      value: newSectionValue,
      modified: true
    });
    return newSections;
  };

  var clearValue = function clearValue() {
    publishValue({
      value: valueManager.emptyValue,
      referenceValue: state.referenceValue,
      sections: getSectionsFromValue(valueManager.emptyValue)
    });
  };

  var clearActiveSection = function clearActiveSection() {
    if (activeSectionIndex == null) {
      return;
    }

    var activeSection = state.sections[activeSectionIndex];
    var activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
    var nonEmptySectionCountBefore = activeDateManager.getSections(state.sections).filter(function (section) {
      return section.value !== '';
    }).length;
    var hasNoOtherNonEmptySections = nonEmptySectionCountBefore === (activeSection.value === '' ? 0 : 1);
    var newSections = setSectionValue(activeSectionIndex, '');
    var newActiveDate = hasNoOtherNonEmptySections ? null : utils.getInvalidDate();
    var newValues = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
    publishValue(_extends({}, newValues, {
      sections: newSections
    }));
  };

  var updateValueFromValueStr = function updateValueFromValueStr(valueStr) {
    var parseDateStr = function parseDateStr(dateStr, referenceDate) {
      var date = utils.parse(dateStr, format);

      if (date == null || !utils.isValid(date)) {
        return null;
      }

      var sections = buildSectionsFromFormat({
        utils: utils,
        timezone: timezone,
        localeText: translations,
        localizedDigits: localizedDigits,
        format: format,
        date: date,
        formatDensity: formatDensity,
        shouldRespectLeadingZeros: shouldRespectLeadingZeros,
        enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
        isRtl: isRtl
      });
      return mergeDateIntoReferenceDate(utils, timezone, date, sections, referenceDate, false);
    };

    var newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
    var newReferenceValue = fieldValueManager.updateReferenceValue(utils, newValue, state.referenceValue);
    publishValue({
      value: newValue,
      referenceValue: newReferenceValue,
      sections: getSectionsFromValue(newValue, state.sections)
    });
  };

  var updateSectionValue = function updateSectionValue(_ref2) {
    var activeSection = _ref2.activeSection,
        newSectionValue = _ref2.newSectionValue,
        shouldGoToNextSection = _ref2.shouldGoToNextSection;

    /**
     * 1. Decide which section should be focused
     */
    if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) {
      setSelectedSections(activeSectionIndex + 1);
    }
    /**
     * 2. Try to build a valid date from the new section value
     */


    var activeDateManager = fieldValueManager.getActiveDateManager(utils, state, activeSection);
    var newSections = setSectionValue(activeSectionIndex, newSectionValue);
    var newActiveDateSections = activeDateManager.getSections(newSections);
    var newActiveDate = getDateFromDateSections(utils, newActiveDateSections, localizedDigits);
    var values;
    var shouldPublish;
    /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */

    if (newActiveDate != null && utils.isValid(newActiveDate)) {
      var mergedDate = mergeDateIntoReferenceDate(utils, timezone, newActiveDate, newActiveDateSections, activeDateManager.referenceDate, true);
      values = activeDateManager.getNewValuesFromNewActiveDate(mergedDate);
      shouldPublish = true;
    } else {
      values = activeDateManager.getNewValuesFromNewActiveDate(newActiveDate);
      shouldPublish = (newActiveDate != null && !utils.isValid(newActiveDate)) !== (activeDateManager.date != null && !utils.isValid(activeDateManager.date));
    }
    /**
     * Publish or update the internal state with the new value and sections.
     */


    if (shouldPublish) {
      return publishValue(_extends({}, values, {
        sections: newSections
      }));
    }

    return setState(function (prevState) {
      return _extends({}, prevState, values, {
        sections: newSections,
        tempValueStrAndroid: null
      });
    });
  };

  var setTempAndroidValueStr = function setTempAndroidValueStr(tempValueStrAndroid) {
    return setState(function (prev) {
      return _extends({}, prev, {
        tempValueStrAndroid: tempValueStrAndroid
      });
    });
  };

  React.useEffect(function () {
    var sections = getSectionsFromValue(state.value);
    validateSections(sections, valueType);
    setState(function (prevState) {
      return _extends({}, prevState, {
        sections: sections
      });
    });
  }, [format, utils.locale, isRtl]); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(function () {
    var shouldUpdate;

    if (!valueManager.areValuesEqual(utils, state.value, valueFromTheOutside)) {
      shouldUpdate = true;
    } else {
      shouldUpdate = valueManager.getTimezone(utils, state.value) !== valueManager.getTimezone(utils, valueFromTheOutside);
    }

    if (shouldUpdate) {
      setState(function (prevState) {
        return _extends({}, prevState, {
          value: valueFromTheOutside,
          referenceValue: fieldValueManager.updateReferenceValue(utils, valueFromTheOutside, prevState.referenceValue),
          sections: getSectionsFromValue(valueFromTheOutside)
        });
      });
    }
  }, [valueFromTheOutside]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    state: state,
    activeSectionIndex: activeSectionIndex,
    parsedSelectedSections: parsedSelectedSections,
    setSelectedSections: setSelectedSections,
    clearValue: clearValue,
    clearActiveSection: clearActiveSection,
    updateSectionValue: updateSectionValue,
    updateValueFromValueStr: updateValueFromValueStr,
    setTempAndroidValueStr: setTempAndroidValueStr,
    getSectionsFromValue: getSectionsFromValue,
    sectionsValueBoundaries: sectionsValueBoundaries,
    localizedDigits: localizedDigits,
    timezone: timezone
  };
};